/* 开发相关 */
export default [
  {
    path: '/dev',
    name: 'dev',
    component: () => import('@/views/layout'),
    meta: {
      title: '开发相关',
      icon: 'el-icon-document',
      breadcrumb: true
    },
    children: [
      {
        path: '/dev/test',
        name: 'devtest',
        component: () => import('@/views/dev/test.vue'),
        meta: {
          title: '测试',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      },
      {
        path: '/dev/index',
        name: 'index',
        component: () => import('@/views/dev/index.vue'),
        meta: {
          title: '',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      },
      {
        path: '/dev/flow',
        name: 'flow',
        component: () => import('@/views/dev/flow.vue'),
        meta: {
          title: '',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      },
      {
        path: '/dev/card',
        name: 'card',
        component: () => import('@/views/dev/card.vue'),
        meta: {
          title: 'card',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      },
      {
        path: '/dev/button',
        name: 'button',
        component: () => import('@/views/dev/button.vue'),
        meta: {
          title: 'button1111',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      },
      {
        path: '/dev/upload',
        name: 'upload',
        component: () => import('@/views/dev/upload.vue'),
        meta: {
          title: 'upload',
          icon: 'el-icon-document',
          breadcrumb: true
        }
      }
      // {
      //   path: '/dev/chart',
      //   name: 'chart',
      //   component: () => import('@/views/dev/chart.vue'),
      //   meta: {
      //     title: '图表',
      //     icon: 'el-icon-document',
      //     breadcrumb: true
      //   }
      // },
      // {
      //   path: '/dev/table',
      //   name: 'table',
      //   component: () => import('@/views/dev/table.vue'),
      //   meta: {
      //     title: '表格',
      //     icon: 'el-icon-document',
      //     breadcrumb: true
      //   }
      // }

      // {
      //   path: "/companyManagement",
      //   //   name: 'home',
      //   component: layoutComponent,
      //   isOnlyOneLevel: true,
      //   meta: {
      //     title: "menu.companyManagement",
      //     icon: "el-icon-menu",
      //     breadcrumb: true,
      //     buttons: [
      //       { code: 'scan', name: '浏览' },
      //       { code: 'view', name: '查看' }
      //     ]
      //   },
      //   children: [
      //     {
      //       path: "",
      //       name: "companyManagement",
      //       component: () => import("@/views/companyManagement/index.vue"),
      //       meta: {
      //         isOnlyOneLevel: true
      //         // title: '测试',
      //         // icon: 'el-icon-document',
      //         // breadcrumb: true
      //       }
      //     },
      //     {
      //       path: '/companyManagement/companyInfoView',
      //       name: 'companyInfoView',
      //       component: () => import('@/views/companyManagement/companyInfoView'),
      //       meta: {
      //         title: 'menu.companyInfoView',
      //         icon: 'el-icon-document',
      //         breadcrumb: true,
      //         routeNameParent: 'companyManagement',
      //         isOnlyOneLevel: true
      //       }
      //     }
      //   ]
      // }
    ]
  }
]
